/**
 * Boulder: boulder.png — damage on first flask collision; physics body is an ellipse.
 */
import { gameImageUrl } from "../../assets/game-image-urls.js";
import { getCachedImage } from "../../assets/image-cache.js";

function getBoulderImage() {
  return getCachedImage(gameImageUrl("boulder"));
}

export class RunBoulder {
  constructor(bottomCenterPosition, slot, progress, width) {
    this.bottomCenterPosition = bottomCenterPosition;
    this.slot = slot;
    this.progress = progress;
    this.width = width;
    this.collected = false;
    this.hasDamaged = false;
  }

  getType() { return "boulder"; }

  getAspectRatio() {
    var img = getBoulderImage();
    if (img && img.naturalWidth > 0) {
      return img.naturalWidth / img.naturalHeight;
    }
    return 1.0;
  }

  getDrawImage() {
    return getBoulderImage();
  }

  draw(ctx, pixelX, pixelY, pixelW, pixelH) {
    if (this.collected) return;
    var boulderImg = getBoulderImage();
    ctx.save();
    if (boulderImg) {
      ctx.imageSmoothingEnabled = true;
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(boulderImg, pixelX, pixelY, pixelW, pixelH);
    } else {
      ctx.fillStyle = "#7c6b4f";
      ctx.beginPath();
      ctx.ellipse(pixelX + pixelW / 2, pixelY + pixelH / 2, pixelW / 2, pixelH / 2, 0, 0, Math.PI * 2);
      ctx.fill();
      ctx.fillStyle = "#4a3f2f";
      ctx.font = "bold 14px monospace";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText("B", pixelX + pixelW / 2, pixelY + pixelH / 2);
    }
    ctx.restore();
  }
}